import React, { FC, useEffect, useRef, useState } from 'react'
import './Pingform.scss'
import { getPayload } from '~utils/forgerock'

interface IPingformProps {
  step
}

const getResumeURL = () => {
  const payload = getPayload()
  const cburl = payload.baseCallbackUrl
  if (cburl.length - 1 === cburl.lastIndexOf('/')) {
    return cburl.substring(0, cburl.lastIndexOf('/')) + payload.resumePath
  } else {
    return cburl + payload.resumePath
  }
}

const getamJwt = step => {
  const sessionToken = step?.getSessionToken()

  let amTokenBase64
  if (sessionToken != null) {
    const amJwt = sessionToken.split('..*')[1]
    amTokenBase64 = amJwt.replace(/-/g, '+').replace(/_/g, '/')
    return amTokenBase64
  }
  return undefined
}

const Pingform: FC<IPingformProps> = ({ step }) => {
  const pingFormRef = useRef<HTMLFormElement>(null)
  const [formData, setFormData] = useState({
    token: 'a',
    click: 'a',
  })

  useEffect(() => {
    setFormData({
      token: getamJwt(step),
      click: 'submit',
    })
  }, [])

  useEffect(() => {
    const submitPingForm = () => {
      if (pingFormRef.current && formData.token !== 'a') {
        pingFormRef.current.action = getResumeURL()
        pingFormRef.current.submit()
      }
    }

    submitPingForm()
  }, [formData])
  return (
    <div className="Pingform" data-testid="Pingform">
      <form id="ping1" action="" method="POST" className="d-none" ref={pingFormRef}>
        <input id="ts1" type="hidden" name="nwas_token" value={formData.token} />
        <input id="ts2" type="hidden" name="nwas_click" value={formData.click} />
      </form>
    </div>
  )
}

export default Pingform
